import { useParams } from 'react-router';
import DataPrivacyFormComponent from './DataPrivacyFormComponent';
import { useEffect, useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';

  const AfterSubmitMessage = () => {
		const { t } = useTranslation('data_privacy');
		return (
			<div>
				<p className="whitespace-pre-line kokot-prasivy">
					<Trans t={t} i18nKey="submit_message" components={{ strong: <strong /> }} />
				</p>
			</div>
		);
	}

export function DataPrivacyRoute() {
  const [showForm, setShowForm] = useState(true);
  const { t, i18n } = useTranslation('data_privacy');

  const { embedded, language } = useParams();

  // for embedded form
  const isEmbedded = embedded === 'embedded';

  useEffect(() => {
    if (isEmbedded) {
      document.querySelector('body')?.classList.add('bg-[#F8F9FA]');
      document.querySelector('#header')?.classList.add('hidden');
      document.querySelector('#footer')?.classList.add('hidden');
    }
  }, [isEmbedded]);

  useEffect(() => {
    const lang = language?.toLowerCase();
    if (lang === 'en' || lang === 'de') {
      i18n.changeLanguage(lang);
    }
  }, [language, i18n]);

  return isEmbedded ? (
    <div className="bg-gray-50 rounded-xl p-6 text-[#454545] mb-16">
      {showForm ? <DataPrivacyFormComponent onSuccessfulSubmit={() => setShowForm(false)} /> : <AfterSubmitMessage />}
    </div>
  ) : (
    <div className="w-full max-w-2xl text-white px-4">
      <h1 className="text-md mt-16 opacity-75 capitalize">{t('consent_declaration')}</h1>
      <h2 className="font-bold text-4xl mb-16 whitespace-pre-line">{t('heading')}</h2>
      <p className="mb-8 whitespace-pre-line">
        <Trans
          t={t}
          i18nKey="text"
          components={[
            <a key="download" href="./datenschutzinformation-termios.pdf" download className="underline hover:no-underline">
              {}
            </a>,
          ]}
        />
      </p>

      <div className="bg-gray-50 rounded-xl shadow-lg border border-gray-200 p-6 text-[#454545] mb-16">
        <h2 className="mb-6 font-semibold text-2xl">{t('digital_consent_declaration')}</h2>
        {showForm ? <DataPrivacyFormComponent onSuccessfulSubmit={() => setShowForm(false)} /> : <AfterSubmitMessage />}
      </div>
    </div>
  );
}

export default DataPrivacyRoute;
